// extracted by mini-css-extract-plugin
module.exports = {"container":"marquee_container__87DdB","heading-container":"marquee_heading-container__zTkx9","left-align":"marquee_left-align__FLevW"};